import { ERRORS_MESSAGE } from "@lhd/constants";
import { Checkbox, Form, Input, Space } from "antd";
import { Dispatch, SetStateAction, useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";

type OptionAddProps = {
  isClicked?: boolean;
  blurFields?: Record<number, boolean>;
  setBlurFields?: Dispatch<SetStateAction<Record<number, boolean>>>;
};

const OptionAdd = ({
  isClicked,
  blurFields,
  setBlurFields,
}: OptionAddProps) => {
  const form = Form.useFormInstance();
  const options = Form.useWatch(["item_config_data", "options"], form);

  return (
    <div>
      <Form.List name={["item_config_data", "options"]}>
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map(({ key, name, ...restField }) => {
                const currentValue = options?.[name]?.text;
                const hasValue = currentValue && currentValue.trim() !== "";

                return (
                  <Space key={key} style={{ display: "flex" }} align="baseline">
                    <Form.Item
                      {...restField}
                      name={[name, "default_checked"]}
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked) {
                            // Uncheck all other checkboxes
                            const options =
                              form.getFieldValue([
                                "item_config_data",
                                "options",
                              ]) || [];
                            options.forEach((_: any, idx: number) => {
                              if (idx !== name) {
                                form.setFieldValue(
                                  [
                                    "item_config_data",
                                    "options",
                                    idx,
                                    "default_checked",
                                  ],
                                  false,
                                );
                              }
                            });
                          }
                        }}
                      />
                    </Form.Item>
                    <div>
                      <Form.Item
                        {...restField}
                        name={[name, "text"]}
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message: "",
                          },
                          {
                            validator: async (_, value) => {
                              if (!value) return;
                              const options =
                                form.getFieldValue([
                                  "item_config_data",
                                  "options",
                                ]) || [];
                              const duplicates = options.filter(
                                (opt: any, idx: number) =>
                                  opt?.text?.trim() === value?.trim() &&
                                  idx !== name &&
                                  value?.trim(),
                              );
                              if (duplicates.length > 0) {
                                return Promise.reject(
                                  new Error(ERRORS_MESSAGE.DUPLICATE_OPTION),
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                        style={{ marginBottom: "2px" }}
                      >
                        <Input
                          placeholder="選択肢を入力してください"
                          className={hasValue ? "has-value" : "no-value"}
                          onChange={() => {
                            // Validate all option fields to check duplicates
                            const options =
                              form.getFieldValue([
                                "item_config_data",
                                "options",
                              ]) || [];
                            options.forEach((_: any, idx: number) => {
                              form.validateFields([
                                ["item_config_data", "options", idx, "text"],
                              ]);
                            });
                          }}
                          onBlur={() =>
                            setBlurFields?.((prev) => ({
                              ...prev,
                              [name]: true,
                            }))
                          }
                        />
                      </Form.Item>
                      {!hasValue && (isClicked || blurFields?.[name]) && (
                        <p
                          className="ant-form-item-explain-error"
                          style={{ marginTop: "-4px" }}
                        >
                          必須項目です
                        </p>
                      )}
                    </div>
                    <div>
                      <IoMdAdd onClick={() => add()} />
                      <AiOutlineMinus
                        onClick={() => {
                          if (key !== 0) {
                            remove(name);
                            setTimeout(() => {
                              form.validateFields();
                            }, 100);
                          }
                        }}
                      />
                    </div>
                  </Space>
                );
              })}
            </>
          );
        }}
      </Form.List>
    </div>
  );
};

export default OptionAdd;
